import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ArrowLeft icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ArrowLeft } from '@sravni/design-system-icons'
 *
 * <ArrowLeft />
 * ```
 */
var ArrowLeft = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ArrowLeft", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m13 4-6 6 6 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ArrowLeft };
//# sourceMappingURL=ArrowLeft.js.map
